import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { BREAKPOINT_MD, BUTTON_STYLES, ICONS } from '../../constants/constants';
import { BackdropService } from '../../services/backdrop.service';
import { AuthService } from '../../services/auth.service';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { NavigationItem } from '../desktop-navigation-dropdown/types';
import { ROUTES } from '../../constants/routes';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  protected readonly ICONS = ICONS;
  protected readonly BUTTON_STYLES = BUTTON_STYLES;

  public user$ = this.authService.user$;

  @Input() showNavigation = true;
  @Input() solid = true;

  private innerWidth: number = window.innerWidth;
  public isPublicMobileMenuOpen: boolean = false;
  public isPrivateMobileMenuOpen: boolean = false;
  public publicNavigationItems: NavigationItem[] = [
    {
      title: 'home',
      path: `/`,
    },
    {
      title: 'contact_us',
      path: `/${ROUTES.CONTACT_US}`,
    },
  ];

  @HostListener('window:resize')
  onResize(): void {
    this.innerWidth = window.innerWidth;

    if (!this.isMobileView) {
      this.closePublicMenu();
      this.closePrivateMenu();
    }
  }

  constructor(
    private backdropService: BackdropService,
    private authService: AuthService,
    private notificationsService: NotificationsService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  get privateNavigationItems(): NavigationItem[] {
    return UtilsService.getNavigationItems(this.authService);
  }

  ngOnInit(): void {
    this.backdropService.getActiveOverlay$().subscribe((backdrop) => {
      if (!backdrop) {
        if (this.isPublicMobileMenuOpen) {
          this.closePublicMenu();
        }

        if (this.isPrivateMobileMenuOpen) {
          this.closePrivateMenu();
        }

        this.cdr.detectChanges();
      }
    });
  }

  get isMobileView(): boolean {
    return this.innerWidth <= BREAKPOINT_MD;
  }

  get isDesktopNavigation(): boolean {
    return !this.isMobileView;
  }

  closeMobileMenu(): void {
    this.backdropService.setOverlay(null);
  }

  openPublicMenu(): void {
    this.closePrivateMenu();

    this.isPublicMobileMenuOpen = true;
    this.openMobileMenu();
  }

  closePublicMenu(): void {
    this.isPublicMobileMenuOpen = false;
    this.closeMobileMenu();
  }

  openPrivateMenu(): void {
    this.closePublicMenu();

    this.isPrivateMobileMenuOpen = true;
    this.openMobileMenu();
  }

  closePrivateMenu(): void {
    this.isPrivateMobileMenuOpen = false;
    this.closeMobileMenu();
  }

  openMobileMenu(): void {
    this.backdropService.setOverlay('backdrop-content--dark');
  }

  logout(): void {
    this.authService.logout().subscribe(() => {});
    this.router.navigate(['']);
    this.closePrivateMenu();
  }
}
